import React, { useEffect } from "react";
import { Button, Container, Sheet, HeadingText, BodyText } from '@paypalcorp/pp-react';
import * as FPT from '../../utility/fpt';
import { launchRedirect } from '../../lib/validate';
import withTheme from "../withTheme";

function DafExclusion(props) {
    const onCloseSheet = () => {
        FPT.trackButtonClick('closeDafExclusion');
        launchRedirect('/givingfund/home');
    }

    useEffect(() => {
        FPT.trackPage(`main:givingfund:${props.propertyInfo.pageName}`);
    }, [])

    return (
        <Sheet isOpen={true} showLogo={true} onCloseComplete={onCloseSheet} title={props.propertyInfo.title} hideTitle={true} style={{ textAlign: 'center' }}>
            <img src={props.propertyInfo.image} alt='' style={{ margin: '2rem 0', width: '8rem' }} />
            <HeadingText level={1}>{props.propertyInfo.title}</HeadingText>
            <BodyText as='p' style={{ margin: '1.5rem 0' }}>{props.propertyInfo.descFirst}</BodyText>
            <BodyText as='p' style={{ margin: '1.5rem 0' }}>{props.propertyInfo.descSecond}</BodyText>
            <Button data-fpti={props.propertyInfo.btnFpti} onClick={() => launchRedirect(props.propertyInfo.linkOne)}>{props.propertyInfo.button}</Button>
        </Sheet>
    )
}
export default withTheme(DafExclusion);